import html2canvas from "html2canvas";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export const captureAndDownloadCharts = async (
  name,
  tabsValue,
  chartRefs,
  setLoading
) => {
  setLoading(true);
  const zip = new JSZip();
  let charts = [];

  const tabMapping = {
    0: [
      { ref: chartRefs.stepsOverview, name: "steps_Overview.png" },
      { ref: chartRefs.stepsAndDistanceRef, name: "distance.png" },
      { ref: chartRefs.floorsRef, name: "floors.png" },
      {ref: chartRefs.elevationRef, name:"elevation.png"}

    ],
    1: [
      { ref: chartRefs.exerciseOverview, name: "exercise_Overview.png" },
      { ref: chartRefs.exerciseInsights, name: "exercise_Insights.png" },
    ],
    2: [
      { ref: chartRefs.sleepOverview, name: "sleep_Overview.png" },
      { ref: chartRefs.sleepInsights, name: "sleep_Insights.png" },
    ],
    3: [{ ref: chartRefs.consumptionInsights, name: "liquids_Overview.png" }],
    4: [{ ref: chartRefs.heartRateOverview, name: "heart_Rate_Overview.png" }],
    5: [{ ref: chartRefs.dailyCaloriesOverview, name: "daily_calories.png" }],
    8: [
      {
        ref: chartRefs.weightChartInsights,
        name: "weightInsights.png",
      },
    ],
  };

  charts = tabMapping[tabsValue] || [];

  for (let { ref, name } of charts) {
    if (ref && ref.current) {
      try {
        const canvas = await html2canvas(ref.current);
        const imgData = canvas.toDataURL("image/png");
        zip.file(name, imgData.split(",")[1], { base64: true });
      } catch (error) {
        console.error("Error capturing chart:", error);
      }
    }
  }

  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(content, `${name}_Charts.zip`);
    setLoading(false);
  });
};
